import Vue from 'vue'
import Router from 'vue-router'
import { requireAuth, skipIfAuth } from '@/modules/auth'


Vue.use(Router);

const Cashboxs = () => import('@/modules/Cashbox/components/Cashboxs')
const Cashbox = () => import('@/modules/Cashbox/components/Cashbox')
const Users = () => import('@/modules/user/components/Users')
const Organizations = () => import('@/modules/Organizations/components/Organizations')
const OrganizationsTerminals = () => import('@/modules/Organizations/components/OrganizationsTerminals')
const OrganizationsClients = () => import('@/modules/Organizations/components/OrganizationsClients')
const OrganizationsCoupons = () => import('@/modules/Organizations/components/OrganizationsCoupons')
const Login = () => import('@/pages/Login')
const ForgotPassword = () => import('@/pages/ForgotPassword')
const ResetPassword = () => import('@/pages/ResetPassword')
const Dashboard = () => import('@/pages/Dashboard')
const NotFound = () => import('@/pages/NotFound')
// const Test = () => import('@/pages/Test')

const Terminals = () => import('@/modules/Terminals/components/Terminals')
const Terminal = () => import('@/modules/Terminals/components/Terminal')
const Clients = () => import('@/modules/Clients/components/Clients')
const Coupons = () => import('@/modules/Coupons/components/Coupons')
const CouponsServices = () => import('@/modules/Coupons/components/CouponServices')
const Reports = () => import ('@/modules/Reports/components/Reports')
const Members = () => import ('@/modules/Members/components/Members')
const MemberJoin = () => import ('@/modules/Members/components/MemberJoin')

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Авторизация'
      },
      beforeEnter: skipIfAuth
    },
    {
      path: '/forgot-password',
      name: 'forgot_password',
      component: ForgotPassword,
      meta: {
        title: 'Восстановление пароля'
      },
      beforeEnter: skipIfAuth
    },
    {
      path: '/reset-password',
      name: 'reset_password',
      component: ResetPassword,
      meta: {
        title: 'Восстановление пароля'
      },
      beforeEnter: skipIfAuth
    },
    {
      path: '/organizations/:orgId/join',
      name: 'join_member',
      component: MemberJoin,
      meta: {
        title: 'Регистрация'
      }
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Главная'
      },
      beforeEnter: requireAuth,
      children: [
        // admin navigation
        {
          path: '/organizations',
          component: Organizations,
          meta: {
            title: 'Компании'
          }
        },
        {
          path: '/organizations-terminals/:org_id',
          component: OrganizationsTerminals,
          meta: {
            title: 'Терминалы организации'
          }
        },
        {
          path: '/organizations-clients',
          component: OrganizationsClients,
          meta: {
            title: 'Клиенты организации'
          }
        },
        {
          path: '/organizations-coupons',
          component: OrganizationsCoupons,
          meta: {
            title: 'Промокоды организации'
          }
        },
        // owner navigation
        {
          path: '/terminals/:terminalId',
          component: Terminal,
          meta: {
            title: 'Терминал'
          }
        },
        {
          path: '/cashboxs',
          component: Cashboxs,
          meta: {
            title: 'ККТ'
          }
        },
        {
          path: '/cashboxs/:kkt_id',
          component: Cashbox,
          meta: {
            title: 'Касса'
          }
        },
        {
          path: '/terminals',
          component: Terminals,
          meta: {
            title: 'Терминалы'
          }
        },
        {
          path: '/users',
          component: Users,
          meta: {
            title: 'Пользователи'
          }
        },
        {
          path: '/clients',
          component: Clients,
          meta: {
            title: 'Клиенты'
          }
        },
        {
          path: '/coupons',
          component: Coupons,
          meta: {
            title: 'Промокоды'
          }
        },
        {
          path: '/coupon/:coupon_id',
          component: CouponsServices,
          meta: {
            title: 'Промокод'
          }
        },
        {
          path: '/reports',
          component: Reports,
          meta: {
            title: 'Отчеты'
          }
        },
        {
          path: '/admin-reports',
          component: Reports,
          meta: {
            title: 'Отчеты',
            orgFilter: true
          }
        },
        {
          path: '/members',
          component: Members,
          meta: {
            title: 'Сотрудники'
          }
        },
        // {
        //   path: '/test',
        //   name: 'test',
        //   component: Test,
        //   meta: {
        //     title: 'Test'
        //   },
        // },
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
})
const basePageTitle = document.title;

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} · ${basePageTitle}`
  } else {
    document.title = basePageTitle
  }

  next()
});

export default router
